export const gridTeaser = {
  itemHeight: '430px',
  itemWidth: '100%',
  indicatorHeight: '100px',
  indicatorWidth: '150px'
};
